export const CREATE_IMAGE = 'CREATE_IMAGE';
export const CREATE_IMAGE_SUCCESS = 'CREATE_IMAGE_SUCCESS';
export const CREATE_IMAGE_ERROR = 'CREATE_IMAGE_ERROR';
export const RESET_IMAGE = 'RESET_IMAGE';

export const CREATE_IMAGE_BY_URL = 'CREATE_IMAGE_BY_URL';
export const CREATE_IMAGE_BY_URL_SUCCESS = 'CREATE_IMAGE_BY_URL_SUCCESS';
export const CREATE_IMAGE_BY_URL_ERROR = 'CREATE_IMAGE_BY_URL_ERROR';
export const RESET_IMAGE_BY_URL = 'RESET_IMAGE_BY_URL';
